<div class="ss-wrap" [class.disabled]="disabled">
  <button
    type="button"
    class="ss-pill"
    (click)="toggleOpen($event)"
    [disabled]="disabled"
    [class.invalid]="invalid"
    [class.open]="isOpen"
  >
    <span class="ss-pill-label">{{ selectedLabel || '-' }}</span>
    <span class="ss-caret">▾</span>
  </button>

  <div class="ss-pop" *ngIf="isOpen" (click)="swallow($event)">
    <div class="ss-search" (click)="swallow($event)">
      <input
        type="text"
        [placeholder]="placeholder"
        [ngModel]="query"
        (ngModelChange)="onQueryInput($event)"
        autocomplete="off"
      />
      <button type="button" class="ss-clear" (click)="onCloseClick($event)" aria-label="Close">×</button>
    </div>

    <div class="ss-list" (click)="swallow($event)">
      <button
        type="button"
        class="ss-opt"
        *ngFor="let opt of filtered"
        (mousedown)="selectOnMouseDown($event, opt)"
        [class.active]="opt.id === selectedId"
      >
        <div class="ss-opt-main">{{ opt.label }}</div>
        <div class="ss-opt-sub" *ngIf="opt.subLabel">{{ opt.subLabel }}</div>
      </button>

      <div class="ss-empty" *ngIf="!filtered.length">No results</div>
    </div>
  </div>
</div>